import './App.css';
import { useBussinesDetails } from './hooks/useBussinesDetails';
import StatusInfo from './components/StatusInfo';
import { useContact } from './hooks/useContact';
import StatusInfoDemo from './components/StatusInfoDemo';
import CONFIG from './configuration/config';

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const demo = urlParams.get('demo');

  const { data, loading, error, handleCancelRequest } = useBussinesDetails();
  const { dataContac, loadingContact, errorContact, handleCancelRequestContact } = useContact();
  return (
    <div className={'App ' + CONFIG.THEME || ''}>
      <div className="status-step">
        {loading && <li className="loading">Loading Detalle Negocio...</li>}
        {loadingContact && <li className="loading">Loading Contact...</li>}
        {error && <li>Error al traer el estado: {error?.message}</li>}
        {errorContact && <li>Error al traer el contacto: {error?.message}</li>}
        {dataContac && (
          <>
            <h3 className="text-title close">
              Hola <br />{' '}
              {(dataContac.data?.contact?.firstName ?? '') + ' ' + (dataContac.data?.contact?.lastName ?? '')}
              <button className="logout-button" onClick={logout}>
                Cerrar Sesión
              </button>
            </h3>
          </>
        )}
      </div>
      {!data && demo && <StatusInfoDemo />}
      {data && (
        <StatusInfo
          periodDB={data.data?.periodDB}
          programDB={data.data?.programDB}
          programTypeDB={data.data?.programTypeDB}
          subPeriodDB={data.data?.subPeriodDB}
          subStateManagment={data.data?.subStateManagment}
        />
      )}
    </div>
  );
}

function logout() {
  localStorage.removeItem(CONFIG.TOKEN);
  window.location.href = CONFIG.URLREDIRECT;
}

export default App;
